/**
 * Formats a monetary amount according to the specified locale
 * @param amount Amount in currency unit
 * @param locale The locale code
 * @returns Formatted money string with the appropriate decimal and thousand separators and currency format
 */
export const formatCurrency = (amount: number, locale: string): string => {
  // Set locale-specific number format
  const localeFormat = locale === 'da' ? 'da-DK' : 'en-US';

  // Format the number with appropriate separators based on locale
  const formattedNumber = new Intl.NumberFormat(localeFormat, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  }).format(amount);

  // Return the formatted string based on locale
  return locale === 'da' ? `${formattedNumber} kr.` : `DKK ${formattedNumber}`;
};

/**
 * Formats a monetary amount according to the specified locale
 * @param amount Amount in smallest currency unit (e.g., øre, cents)
 * @param locale The locale code
 * @returns Formatted money string with the appropriate decimal and thousand separators and currency format
 */
export const formatCurrencyFromCents = (amount: number, locale: string): string => {
  // Convert amount from smallest currency unit to main unit
  const amountInMainUnit = amount / 100;

  // Set locale-specific number format
  const localeFormat = locale === 'da' ? 'da-DK' : 'en-US';

  // Format the number with appropriate separators based on locale
  const formattedNumber = new Intl.NumberFormat(localeFormat, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  }).format(amountInMainUnit);

  // Return the formatted string based on locale
  return locale === 'da' ? `${formattedNumber} kr.` : `DKK ${formattedNumber}`;
};
